import { useTranslation } from 'react-i18next';
import { useUnit } from 'effector-react';
import { IconButton, Typography } from '@mui/material';
import { ArrowBack, Menu, MenuOpen } from '@mui/icons-material';
import { SectionDescriptionButton } from '@features/common';
import ContactCalls from '@features/contact-calls';
import { ExportTemporal } from '@features/export-temporal';
import { ImportTemporal } from '@features/import-temporal';
import { $currentPage, switchMenuFixed, $isFixed } from '@features/navbar/models';
import { NewsFeedBadge } from '@features/news-feed-badge';
import Notifications from '@features/notifications';
import { ProfileLink } from '@features/profile-link';
import ProfileMenu from '@features/profile-menu';
import { ThemeAdapter } from '@shared/theme/adapter';
import * as Styled from './styled';

export const Header = () => {
  const [sectionHeader, isFixed] = useUnit([$currentPage, $isFixed]);
  const { t } = useTranslation();

  return (
    <ThemeAdapter>
      <Styled.AppBar>
        <Styled.ToolBar>
          {sectionHeader && (
            <Styled.Content>
              <Styled.ButtonWrapper>
                <IconButton onClick={switchMenuFixed}>
                  {isFixed ? <MenuOpen /> : <Menu />}
                </IconButton>
              </Styled.ButtonWrapper>

              {sectionHeader.back && (
                <Styled.ButtonWrapper>
                  <IconButton title={t('Back')} onClick={sectionHeader.back}>
                    <ArrowBack />
                  </IconButton>
                </Styled.ButtonWrapper>
              )}
              <Typography variant="h5">{sectionHeader.title}</Typography>
              <SectionDescriptionButton />
            </Styled.Content>
          )}

          <Styled.Menu>
            <ProfileLink />
            <ContactCalls />
            <ImportTemporal />
            <ExportTemporal />
            <NewsFeedBadge />
            <Notifications />
            <ProfileMenu />
          </Styled.Menu>
        </Styled.ToolBar>
      </Styled.AppBar>
    </ThemeAdapter>
  );
};
